import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, input, signal } from '@angular/core';
import { type ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzRadioModule } from 'ng-zorro-antd/radio';

export interface RadioOption {
  value: string | boolean | number;
  label?: string;
  labelHtml?: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'dpqa-radio-group',
  standalone: true,
  imports: [CommonModule, NzRadioModule, FormsModule],
  templateUrl: './radio-group.component.html',
  styleUrl: './radio-group.component.less',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioGroupComponent),
      multi: true,
    },
  ],
})
export class RadioGroupComponent implements ControlValueAccessor {
  // eslint-disable-next-line no-empty-function
  private onChange: (value: string | boolean | number) => void = () => { };
  // eslint-disable-next-line no-empty-function
  private onTouched: () => void = () => { };

  public value = signal<string | boolean | number | null>(null);

  title = input<string>();
  options = input.required<RadioOption[]>();
  disabled = input<boolean>(false);

  writeValue(value: string | boolean | number | null): void {
    this.value.set(value);
  }

  registerOnChange(fn: (value: string | boolean | number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onValueChange(value: string | boolean | number): void {
    this.value.set(value);
    this.onChange(value);
    this.onTouched();
  }
}
